/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PostData model module.
 * @module model/PostData
 * @version 1.0
 */
class PostData {
    /**
     * Constructs a new <code>PostData</code>.
     * @alias module:model/PostData
     */
    constructor() { 
        
        PostData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PostData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PostData} obj Optional instance to populate.
     * @return {module:model/PostData} The populated <code>PostData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PostData();

            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('sentAt')) {
                obj['sentAt'] = ApiClient.convertToType(data['sentAt'], 'Date');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('per')) {
                obj['per'] = ApiClient.convertToType(data['per'], 'Number');
            }
            if (data.hasOwnProperty('xper')) {
                obj['xper'] = ApiClient.convertToType(data['xper'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('postType')) {
                obj['postType'] = ApiClient.convertToType(data['postType'], 'Number');
            }
            if (data.hasOwnProperty('eventNo')) {
                obj['eventNo'] = ApiClient.convertToType(data['eventNo'], 'Number');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PostData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PostData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {Number} postNo
 */
PostData.prototype['postNo'] = undefined;

/**
 * @member {String} title
 */
PostData.prototype['title'] = undefined;

/**
 * @member {Date} sentAt
 */
PostData.prototype['sentAt'] = undefined;

/**
 * @member {Date} expireAt
 */
PostData.prototype['expireAt'] = undefined;

/**
 * @member {Number} itemCount
 */
PostData.prototype['itemCount'] = undefined;

/**
 * @member {Number} per
 */
PostData.prototype['per'] = undefined;

/**
 * @member {Number} xper
 */
PostData.prototype['xper'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
PostData.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Number} userCount
 */
PostData.prototype['userCount'] = undefined;

/**
 * @member {Boolean} enabled
 */
PostData.prototype['enabled'] = undefined;

/**
 * @member {Number} postType
 */
PostData.prototype['postType'] = undefined;

/**
 * @member {Number} eventNo
 */
PostData.prototype['eventNo'] = undefined;

/**
 * @member {Date} createAt
 */
PostData.prototype['createAt'] = undefined;






export default PostData;

